<template>
  <div class="page-container">
    <el-card>
      <app-filter :filter-list="table_filter" @search="onSearch" />
    </el-card>
    <el-card class="mt-20">
      <div class="table-toolbar-wrapper">
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="openLabelDialog('add')">新增标签</el-button>
        <el-button size="mini" type="primary" icon="el-icon-upload2" @click="openLabelDialog('batch')">批量新增标签</el-button>
      </div>
      <app-table ref="tags-table" :table-key="table_config.table_key" :table-props="table_config.table_props" :tablep="table_config.table_params" :get-data="table_config.get_data" />
    </el-card>
    <label-dialog
      :visible.sync="dialog_config.is_show"
      :mode="dialog_config.mode"
      :row="dialog_config.row"
      :game-options="table_filter.parent_game_ids.props.options"
      @confirm="onDialogConfirm"
      @cancel="dialog_config.is_show = false"
    />
  </div>
</template>

<script>
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();
import { getMaterialLabelApi, addMaterialLabelApi, editMaterialLabelApi, deleteMaterialLabelApi } from '@/api/material/label';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'label-dialog': () => import('./components/label-dialog'),
  },
  data() {
    return {
      table_filter: require('./model/table-filter.js')(this),
      table_config: {
        table_props: { stripe: true },
        table_params: { page: 1, limit: 10 },
        table_key: require('./model/table-key.js')(this),
        get_data: this.getMaterialLabel,
      },
      dialog_config: {
        is_show: false,
        mode: 'add',
        row: null,
      },
    };
  },
  mounted() {
    this.setGameData();
  },
  methods: {
    getGameList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource.getGameListApi(params).then(resolve).catch(reject);
      });
    },
    getMaterialLabel(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelApi(params).then(resolve).catch(reject);
      });
    },
    setGameData() {
      this.getGameList({ refresh: 1, is_parent: 1 }).then((res) => {
        const options = (res.list || []).map(item => ({ ...item, disabled: true }));
        this.table_filter.parent_game_ids.props.options = options;
      });
    },
    onSearch(params) {
      const { parent_game_ids } = params || {};
      Object.assign(this.table_config.table_params, { ...params, ...(parent_game_ids && { parent_game_ids: [parent_game_ids] }) });
      this.seekTable();
    },
    seekTable() {
      this.$refs['tags-table'].seekTable();
    },
    refreshTable() {
      this.$refs['tags-table'].refer();
    },
    openLabelDialog(mode) {
      Object.assign(this.dialog_config, {
        is_show: true,
        mode,
        row: null,
      });
    },
    openEditDialog(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        mode: 'edit',
        row,
      });
    },
    onDialogConfirm(payload) {
      const request = this.dialog_config.mode === 'edit'
        ? editMaterialLabelApi(payload.id, payload.data)
        : addMaterialLabelApi(payload);
      request.then(() => {
        this.$message.success(this.dialog_config.mode === 'edit' ? '编辑成功！' : '新增成功！');
        this.refreshTable();
        this.dialog_config.is_show = false;
      });
    },
    onDeleteMaterialLabel(row) {
      const { id, label } = row;
      this.$confirm(`此操作将删除「${label}」标签, 是否继续？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$set(row, 'loading', true);
        deleteMaterialLabelApi(id).then(() => {
          this.$message.success('删除成功！');
          this.seekTable();
        }).finally(() => {
          this.$set(row, 'loading', false);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.material-label-remark-input {
  .el-textarea__inner {
    padding: 0;
    color: #606266;
    line-height: 1.5;
    background: transparent;
    border: 0;
    box-shadow: none;
    cursor: default;
  }
}
</style>
